import classNames, { ArgumentArray } from "classnames";
import get from "lodash.get";
import { twMerge } from "tailwind-merge";

export const getValue = (obj: object, path: string) => {
  return get(obj, path);
};

export const cn = (...classes: ArgumentArray): string => {
  return twMerge(classNames(...classes));
};

export const searchInString = (search: string, value: string): boolean =>
  value.toLowerCase().includes(search.toLowerCase());
